var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.99996V12M12.5 16H12.51M3.5 7.94141V16.0585C3.5 16.4012 3.5 16.5725 3.55048 16.7253C3.59515 16.8605 3.66816 16.9845 3.76463 17.0892C3.87369 17.2076 4.02345 17.2908 4.32297 17.4572L11.723 21.5683C12.0066 21.7258 12.1484 21.8046 12.2985 21.8355C12.4315 21.8628 12.5685 21.8628 12.7015 21.8355C12.8516 21.8046 12.9934 21.7258 13.277 21.5683L20.677 17.4572C20.9766 17.2908 21.1263 17.2076 21.2354 17.0892C21.3318 16.9845 21.4049 16.8605 21.4495 16.7253C21.5 16.5725 21.5 16.4012 21.5 16.0585V7.94141C21.5 7.59876 21.5 7.42744 21.4495 7.27464C21.4049 7.13947 21.3318 7.01539 21.2354 6.9107C21.1263 6.79236 20.9766 6.70916 20.677 6.54276L13.277 2.43164C12.9934 2.27409 12.8516 2.19531 12.7015 2.16442C12.5685 2.13709 12.4315 2.13709 12.2985 2.16442C12.1484 2.19531 12.0066 2.27409 11.723 2.43164L4.32297 6.54276C4.02345 6.70916 3.87369 6.79236 3.76463 6.9107C3.66816 7.01539 3.59515 7.13947 3.55048 7.27464C3.5 7.42744 3.5 7.59876 3.5 7.94141Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFailed);
export default __webpack_public_path__ + "static/media/call-failed.209bb1913abec63802b01746673ef350.svg";
export { ForwardRef as ReactComponent };